import { createApp, nextTick } from 'vue'
import { createHead } from '@unhead/vue/client'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import router from './router'
import { initKeycloak, isAuthenticated, consumePendingRedirect } from './keycloak';
import { isPrerendering } from './seo'

loadFonts()

const app = createApp(App).use(vuetify).use(router).use(createHead())

// Il tema va risolto PRIMA del mount, altrimenti chi usa il dark vede un flash chiaro.
const savedTheme = localStorage.getItem('uqm-theme')
const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
if (savedTheme === 'dark' || (!savedTheme && prefersDark)) {
  vuetify.theme.global.name.value = 'dark'
}

// Il mount NON aspetta Keycloak: le pagine pubbliche (landing, guide) devono comparire
// nell'HTML anche se l'identity provider è lento o irraggiungibile — altrimenti Googlebot
// e il prerender di build fotografano una pagina vuota. Le route protette restano coperte
// dal guard in router/index.js, che fa `await initKeycloak()` per conto suo.
app.mount('#app')

// Durante il prerender non esiste una sessione da ripristinare: evitiamo la chiamata
// di rete verso Keycloak, che rallenterebbe il build senza alcun beneficio.
if (!isPrerendering()) {
  initKeycloak().finally(() => {
    const pendingRedirect = consumePendingRedirect()
    if (pendingRedirect && isAuthenticated() && router.currentRoute.value.path !== pendingRedirect) {
      router.replace(pendingRedirect)
    }
  })
}

// Segnale atteso da @prerenderer in build (renderAfterDocumentEvent): dichiara la pagina
// pronta solo dopo che il router ha risolto la route E unhead ha scritto i tag nel <head>,
// altrimenti puppeteer salverebbe l'HTML senza title, description e JSON-LD.
router.isReady().then(async () => {
  await nextTick()
  setTimeout(() => document.dispatchEvent(new Event('uqm-prerender-ready')), 50)
})
